import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import request from "../../../Apis/request";
import { BaseURL, uniqueToken } from "../../../api/DataApis";
import axios from "axios";

function Edit() {
  let navigate = useNavigate();
  let param = useParams();
  let offerID = param?.wid;

  console.log("offerID", offerID);

  document.title = "Offer | Update";

  const ApiUrl = `${BaseURL}/offer/edit/${offerID}`;
 

 

  const [TitleName, setTitleName] = useState("");
  const [description, setdescription] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [EndDate, setEndDate] =  useState("");
  const [Amount, setAmount] = useState("");
  const [Percentage, setPercentage] =  useState("");
  const [loading, setLoading] = useState(false);
  const [InitialData, setInitialData] =  useState([]);

  useEffect(() => {
    setLoading(true);
    if (InitialData) {
      setTitleName(InitialData?.title);
      setdescription(InitialData?.description);
      setFromDate(InitialData?.start_date);
      setEndDate(InitialData?.end_date);
      setAmount(InitialData?.amount);
      setPercentage(InitialData?.percentage);
    }}, [InitialData]);

  const fetchInitialData = async () => {
    const apiEndpoint = ApiUrl;

    setLoading(true);

    var url = apiEndpoint

    let res = await request({
      url: url,
      method: "GET",
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        Authorization: `Bearer ${uniqueToken}`,
      },
    });

    console.log("res", res);
   
    if (res && res.data) {
      setInitialData(res.data[0]);
      }

    return [];
  };

  useEffect(() => {
    fetchInitialData();
  }, []);

  
console.log("initialData", InitialData);
 



 

  const handleTitleNameChange = (e) => {
    setTitleName(e.target.value);
  };

  const handleDiscriptionChange =(e)=> {
    setdescription(e.target.value);
};

const handleFromDateChange=(e)=> {
  setFromDate(e.target.value);
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
  };
  const handleAmountChange = (e) => {
    setAmount(e.target.value);
  };

  const handlePercentageChange = (e) => {
    setPercentage(e.target.value);
  };

  // Handle additional input value
 

  const UpdateOffer = async () => {
    let formData = new FormData();
    formData.append("title", TitleName);
    // formData.append("status", selectedStatusType);
   
  
     // Add selected OCPP connector to formData

    // Add additional input to formData if applicable
  console.log("description", description);
    if (description) {
      formData.append("description", description);
      }
      if (fromDate) {
        formData.append("start_date", fromDate);
        }
        if (EndDate) {
          formData.append("end_date", EndDate);
          }
          if (Amount) {
            formData.append("amount", Amount);
            }
            if (Percentage) {
              formData.append("percentage", Percentage);
              }

    setLoading(true);
    Swal.fire({
      title: 'Updating Offer...',
      text: 'Please wait',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      let response = await request({
        url: `${BaseURL}/offer/${offerID}`,
        method: "PUT",
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${uniqueToken}`,
        }
      });

      if (response.statusCode === 200) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Offer Updated Successfully...",
          showConfirmButton: false,
          timer: 1500,
        });
        navigate(`/offers/offer-list`);
      } else {
        const errorMessage = response.data.message || "Failed to add Filter Category";
        Swal.fire({
          icon: "error",
          title: "Error",
          text: errorMessage,
        });
      }
    } catch (error) {
      console.error("Error in AddFilterCategory:", error);
      const errorMessage = error.response?.data?.message || "An unexpected error occurred.";
      Swal.fire({
        icon: "error",
        title: "Error",
        text: errorMessage,
      });
    }
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <h1 className="page-title"></h1>
              <div className="portlet light bordered">
                <div className="portlet-title row">
                  <div className="caption font-dark col-md-10">
                    <h4 className="caption-subject bold uppercase mx-3">
                    
                        <h3>Offers Update </h3>
                    
                    </h4>
                  </div>
                  <div className="caption font-dark col-md-2">
                    <h5 className="caption-subject bold uppercase mx-3">
                      <button className="btn btn-success" onClick={() => navigate(-1)}>
                        Back
                      </button>
                    </h5>
                  </div>
                </div>
                <div className="portlet-body mx-3">
                  <hr style={{ marginTop: "-5px" }} />
                  <div className="row">
                    <div className="col-sm-12">
                      <form
                        className="form-horizontal"
                        encType="multipart/form-data"
                        role="form"
                        method="post"
                        style={{ marginTop: "-20px" }}
                      >
                        <div className="form-group">
                          <div className="row">
                            <label
                              htmlFor="name_id"
                              className="col-sm-2 control-label"
                            >
                              Title
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleTitleNameChange}
                                className="form-control"
                                id="name_id"
                                name="name"
                                value={TitleName}
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>

                        <div className="form-group">
                          <div className="row">
                            <label
                              htmlFor="name_id"
                              className="col-sm-2 control-label"
                            >
                              Description
                            </label>
                            <div className="col-sm-6">
                              <textarea
                                onChange={handleDiscriptionChange}
                                className="form-control"
                                id="name_id"
                                value={description}
                                name="name"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label
                              htmlFor="name_id"
                              className="col-sm-2 control-label"
                            >
                            From Date
                            </label>
                            <div className="col-sm-6">
                              <input
                              TYPE="date"
                                onChange={handleFromDateChange}
                                className="form-control"
                                id="name_id"
                                value={fromDate}
                                name="name"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label
                              htmlFor="name_id"
                              className="col-sm-2 control-label"
                            >
                              End Date
                            </label>
                            <div className="col-sm-6">
                              <input
                              type="date"
                                onChange={handleEndDateChange}
                                className="form-control"
                                id="name_id"
                                value={EndDate}
                                name="name"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label
                              htmlFor="name_id"
                              className="col-sm-2 control-label"
                            >
                              Amount
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleAmountChange}
                                className="form-control"
                                id="name_id"
                                value={Amount}
                                name="name"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label
                              htmlFor="name_id"
                              className="col-sm-2 control-label"
                            >
                            Percentage
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handlePercentageChange}
                                className="form-control"
                                id="name_id"
                                value={Percentage}
                                name="name"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                      
                       
                        
             
                       

                        <div className="form-group">
                          <div className="row">
                            <div className="col-sm-6">
                              <button
                                type="button"
                                className="btn btn-success"
                                onClick={UpdateOffer}
                              >
                                Update Offer
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Edit;
